import React, { useState, useEffect, Fragment } from 'react';

import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';

import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { blockListEmployer } from '../../../redux/actions/employer/blockListEmployer';
import { resetApproveEmployer, resetBlockEmployer, resetBlockListEmployer, setSortEmployerList } from '../../../redux/slices/employer.slice';
import { approveEmployer } from '../../../redux/actions/employer/approveEmployer';
import Loading from '../../Loading/Loading';
import { getEmployerStats } from '../../../redux/actions/employer/getEmployerStats';
import VacancyEmpty from '../Vacancy/VacancyEmpty';
import AscendingSvg from '../../Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../Form/SortSvg/DescendingSvg';

function NoBroadCastList({ currentItems, checked, setChecked, showAction, checkedAll, setCheckedAll, onStartFetch }) {
  const {
    getEmployerList: { data: getEmployerListData, error: getEmployerListError, loading: getEmployerListLoading },
    blockListEmployer: { data: blockListEmployerData, error: blockListEmployerError, loading: blockListEmployerLoading },
    sortEmployerList,
  } = useSelector((state) => state.employer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (blockListEmployerData) {
      Swal.fire({
        title: 'Учетные записи контрагентов перемещены в блок "заблокированные"',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetBlockListEmployer());
      onStartFetch();
    }
  }, [blockListEmployerData]);

  const handleBlock = () => {
    Swal.fire({
      title: 'Вы действительно хотите заблокировать выбраных контрагентов?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          blockListEmployer({
            employers: Object.keys(checked)
              ?.filter((key) => checked[key])
              .map((key) => key),
            is_blocked: true,
          }),
        );
      }
    });
  };

  return (
    <table className="w-full divide-y divide-gray-200">
      <thead>
        <tr>
          <th scope="col" className=" py-3 text-start text-[16px] font-medium uppercase">
            <input
              type="checkbox"
              className="h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
              onChange={(e) => {
                setCheckedAll(e.target.checked);
              }}
              checked={checkedAll}
              defaultChecked={checkedAll}
            />
          </th>
          <th scope="col" className="px-2 py-3 text-start text-[14px] font-medium hidden md:table-cell">
            <div
              className="flex flex-row items-center gap-2 cursor-pointer"
              id="id"
              onClick={() => {
                dispatch(setSortEmployerList(!sortEmployerList));
              }}>
              ID
              {!sortEmployerList ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" />}
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-start text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="title">
              Наименование
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="moderation">
              На модерации
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="inactive">
              Не активных
            </div>
          </th>
          <th scope="col" className="pl-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="delete">
              Удалены
            </div>
          </th>
          <th scope="col" className="pl-2 py-1 text-start text-[14px] font-medium">
            {showAction ? (
              <button onClick={handleBlock} className="flex w-fit p-2 text-sm text-gray-800 bg-[#E5E5E5] border-1 border-[#C4C4C4] rounded-md">
                Заблокировать
              </button>
            ) : (
              ''
            )}
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
        {currentItems.map((item) => (
          <tr key={item.key}>
            <td className=" py-4 whitespace-nowrap text-sm text-gray-800">
              <input
                name={item.num}
                type="checkbox"
                checked={checked[item.num]}
                defaultChecked={checked[item.num]}
                onChange={(e) => {
                  setChecked((prev) => ({ ...prev, [item.num]: e.target.checked }));
                }}
                className="select_checkbox h-3 w-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
              />
            </td>
            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800 hidden md:table-cell">{item.num}</td>
            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800">
              <p className="block md:hidden">{item.num}</p>
              <Link to={`/user/${item.num}`}>
                {item.name}
                <br />
                <span className="inline-block text-gray-400 text-xs -translate-y-[2px]">{item.email}</span>
              </Link>
            </td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.moderation}</td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.inactive}</td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.delete}</td>
            <td className="pl-2 py-4 whitespace-nowrap text-center text-sm text-gray-800"></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default NoBroadCastList;
